import { render, staticRenderFns } from "./LocationAdjustment.vue?vue&type=template&id=bea28808"
import script from "./LocationAdjustment.vue?vue&type=script&lang=js"
export * from "./LocationAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports